import React, { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";

import { getPetNameByWorkspaceId } from "../../Api/Services/PetServices";
import { createProvider } from "../../Api/Services/ProviderServices";
import CustomButton from "../../Components/Common/Button";
import FormGroup from "../../Components/Common/FormGroup";
import InputField from "../../Components/Common/InputField";
import { showSnackbar } from "../../Components/Common/Snackbar";
import useAuth from "../../ContextProvider/AuthProvider";
import {
  FormHeaderBox,
  FormHeaderTitle,
  Body,
  Column,
  newSmallFieldBoxStyle,
  ButtonBoxStyle,
  CancelButton,
} from "../../Css";
import { InviteProviderValidation } from "../../From/Validation";
import AutoComplete from "../Common/AutoComplete";
import FormLayout from "../Common/FormHeader";
import { useTheme } from "@mui/material/styles";

const defaultValue = {
  first_name: "",
  last_name: "",
  email: "",
  pet_id: "",
};

const ProviderForm = () => {
  const { workspaceId: w_id } = useAuth();
  const [initialValue, setInitialValue] = useState(defaultValue);
  const navigate = useNavigate();
  const [petNameOptions, setPetNameOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const getPetNames = async () => {
    try {
      const { data } = await getPetNameByWorkspaceId(w_id);
      const petnames = data?.data?.map((pet) => {
        return {
          value: pet?.id,
          label: pet?.name,
        };
      });
      if (petnames.length === 0) {
        console.error("No pet names found for workspace ID:", w_id);
      } else {
        setPetNameOptions(petnames);
      }
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    if (w_id) {
      getPetNames();
    }
  }, [w_id]);

  const handleSubmit = async (values,{isSubmitting}) => {
    const value = {
      ...values,
      w_id: w_id,
    };
    try {
      const res = await createProvider(value);
      showSnackbar({
        type: "success",
        message: "Provider information added successfully",
      });
      setOpen(true);
    } catch (err) {
      showSnackbar({
        type: "error",
        message: "Provider information added failed",
      });
      console.error(err);
      throw err;
    }finally{
      isSubmitting(false);
    }
  };

  return (
    <FormLayout title="Provider Information">
      <Formik
        initialValues={initialValue}
        onSubmit={handleSubmit}
        validationSchema={InviteProviderValidation}
        enableReinitialize
        // innerRef={formRef}
      >
        {({ getFieldProps, values, isSubmitting }) => (
          <Form>
            <Box sx={FormHeaderBox(theme.palette.primary.main)}>
              <Box sx={{ borderBottom: `1px solid ${theme.palette.primary.main}`, width: "100%" }}>
                <Typography variant="h6" sx={FormHeaderTitle}>
                  Provider Details
                </Typography>
              </Box>
              <div className="scroll2" style={{ width: "100%" }}>
                <Body style={{ gap: "10px 20px" }}>
                  <Column>
                    <FormGroup name="pet_id" label={"Pet Name"} requiredField>
                      <AutoComplete
                        {...getFieldProps("pet_id")}
                        name="pet_id"
                        options={petNameOptions}
                        placeholder="Select a Pet Name"
                      />
                    </FormGroup>
                  </Column>
                  <Column>
                    <Box
                      sx={{ ...newSmallFieldBoxStyle, paddingBottom: "0px" }}
                    >
                      <Box style={{ width: "50%" }}>
                        <FormGroup
                          name="first_name"
                          label={"First Name"}
                          requiredField
                        >
                          <InputField {...getFieldProps("first_name")} />
                        </FormGroup>
                      </Box>
                      <Box style={{ paddingLeft: "5px", width: "50%" }}>
                        <FormGroup
                          name="last_name"
                          label={"Last Name"}
                          requiredField
                        >
                          <InputField {...getFieldProps("last_name")} />
                        </FormGroup>
                      </Box>
                    </Box>
                  </Column>
                  <Column>
                    <FormGroup name="email" label={"Email"} requiredField>
                      <InputField {...getFieldProps("email")} />
                    </FormGroup>
                  </Column>
                </Body>
              </div>
              <Box Box sx={ButtonBoxStyle(`${theme.palette.primary.main}`)}>
                <Box display="flex">
                  <CustomButton
                    label="Cancel"
                    type="button"
                    style={CancelButton(`${theme.palette.primary.main}`)}
                    onClick={() => navigate(-1)}
                  />
                  <CustomButton
                    label={isSubmitting ? "Submitting..." : "Submit"}
                    disabled={isSubmitting}
                    type="submit"
                  />
                </Box>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </FormLayout>
  );
};

export default ProviderForm;
